import React, { useEffect, useState } from "react";
import axios from "axios";
import "./style.css";
import Table from "../Table";
import Pagination from "../Pagination";
import Search from "../Search/Search";
import Loading from "../Loading/Loading";

function LeaderBoard({ title }) {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({
          page: page.toString(),
          per_page: perPage.toString(),
          sort_order: "asc",
          min_correct: "1",
          search: searchTerm,
        });

        const apiUrl = `${
          process.env.REACT_APP_API_URL
        }/wp-json/gamipress/v1/weekly-summary?${params.toString()}`;

        const response = await axios.get(apiUrl);
        setData(response.data.results);
        const noOfPages = Math.ceil(response.data.total_results / perPage);
        setTotalPages(noOfPages);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };
    fetchData();
  }, [page, perPage, searchTerm]);
  const handleSearch = (input) => {
    setSearchTerm(input);
    setPage(1);
  };

  const resetSearch = () => {
    setSearchTerm("");
    setPage(1);
  };

  const handlePageChange = (pageNumber, type) => {
    if (type === "next") {
      setLoading(true);
      setPage(pageNumber + 1);
    } else {
      setLoading(true);
      setPage(pageNumber - 1);
    }
  };

  const handlePerPageChange = (event) => {
    const newPerPage = parseInt(event.target.value);
    setPerPage(newPerPage);
    setLoading(true);
    setPage(1);
  };

  return (
    <div className="leaderboard-container">
      <div className="finalResult">
        <div className="h3">{title}</div>
        <Search
          setSearchTerm={setSearchTerm}
          handleSearch={handleSearch}
          resetSearch={resetSearch}
          searchTerm={searchTerm}
        />
      </div>
      {loading ? <Loading /> : <Table data={data} />}
      <Pagination
        pageNumber={page}
        handlePageChange={handlePageChange}
        handlePerPageChange={handlePerPageChange}
        totalPages={totalPages}
        perPage={perPage}
        setLoading={setLoading}
      />
    </div>
  );
}

export default LeaderBoard;
